import React from 'react';
import Popover from './Popover';
import _ from 'lodash';
import {
  EditFiltersMsg,
  EditFiltersQuery,
  LoadFiltersQuery,
  LoadFiltersMsg,
  CollectionMetadataValueObj
} from './autogenerated/ZoomBridge';
import StringUtil from './util/StringUtil';
import ErrorHandler from './error/ErrorHandler';

import './FiltersPopover.css';
import Modal from './modals/Modal2';
import { KeyCode } from './util/Constants';
import t from './i18n/I18n';
import { ThemeSetup } from './themes/ThemeSetup';
import { Div } from './common/elements';
import ToolTip from './common/AssetPropertyView';
import Store from './store/Store';
import { ASSET_FILTERS, CATEGORY_LIST, GLOBAL_SEARCH_INFO } from './store/Constants';
import CreateCollection from './queries/lightbox/crud/CreateCollection';
import { toast } from './store/StoreUtil';
import Button from './common/Button';
import ViewUtil from './ViewUtil';
import { getInnerHeight } from './util/ScreenUtil';

export default class FiltersPopover extends React.Component {
  state = {
    show: false,
    modal: null,
    filterNames: null,
    value: '',
    isCollectionSave: false
  };

  componentDidMount() {
    this._isMounted = true;
    if (_.isEmpty(window.gs.filterNames)) this.loadFilters();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  onClose = () => {
    this.currentFilterName = null;
    this.setState({ modal: null, isCollectionSave: false });
  };

  onChange = (e) => {
    this.setState({ value: e.target.value });
  };

  onKeyDown = (e) => {
    if (e.keyCode === KeyCode.ENTER) {
      this.saveFilter();
    }
  };

  saveCollection = (newName) => {
    const globalSearchInfo = Store.get(GLOBAL_SEARCH_INFO);
    let query = new CreateCollection(newName.trim());
    const collectionMetObj: CollectionMetadataValueObj[] = [];
    const METADATA_KEYS = [];
    if (globalSearchInfo.searchString) {
      const coBj = new CollectionMetadataValueObj();
      coBj.setValue(globalSearchInfo.searchString);
      coBj.setOperator(2);
      coBj.setSearchType(2);
      collectionMetObj.push(coBj);
      METADATA_KEYS.push('SYST_Search Everywhere');
    }
    query.setMetadataProps(METADATA_KEYS);
    query.setMetadataValues(collectionMetObj);
    query
      .run()
      .then(() => toast(t('COLLECTION_ADDED')))
      .catch((err) => ErrorHandler.handleError(err));
  };

  showSearchCollection = () => {
    let isShow = true;
    const globalSearchInfo = Store.get(GLOBAL_SEARCH_INFO);
    const categoryList = Store.get(CATEGORY_LIST);
    const fileFilters = Store.get(ASSET_FILTERS);
    isShow = !!globalSearchInfo.searchString;
    if (!isShow) {
      isShow = categoryList.some((e) => e.isHasAnySelectedItem());
    }

    return isShow;
  };

  render() {
    const globalSearchInfo = Store.get(GLOBAL_SEARCH_INFO);
    const hasSavedSearches = window.gs.filterNames != null && window.gs.filterNames.length > 0;
    const reqWidth = hasSavedSearches ? 250 : 200;
    const isShowSavedSearchBtn: boolean = this.showSearchCollection() && ViewUtil.isAllFileSearchMode();
    const isShowSaveAsCol: boolean = isShowSavedSearchBtn && globalSearchInfo.searchString ? true : false;
    return (
      <div name="FiltersPopover">
        <div
          ref="filters"
          className="saved-filters"
          onClick={() => this.setState({ show: true })}
          style={{
            backgroundImage: this.state.show ? 'url(images/arrow_up.svg)' : 'url(images/arrow_down.svg)'
          }}>
          {t('SAVED_SEARCH')}
        </div>
        {this.state.show ? (
          <Popover
            top={this.refs.filters.getBoundingClientRect().bottom}
            width={reqWidth}
            maxHeight= {getInnerHeight() - this.refs.filters.getBoundingClientRect().bottom - 2}
            overflow={"hidden auto"}
            left={
              this.refs.filters.getBoundingClientRect().right - reqWidth < 10
                ? 10
                : this.refs.filters.getBoundingClientRect().right - reqWidth
            }
            onClose={() => this.setState({ show: false })}>
            <div style={{ width: reqWidth + 'px', fontSize: 14, paddingBottom: 5 }}>
              <Button
                style={{ ...styles.saveCurrentFilters }}
                text={t('SAVE_CURRENT_SEARCH')}
                disabled={!isShowSavedSearchBtn ? true : false}
                onClick={(event) => this.setState({ modal: 'USERINPUT', show: false, value: '' })}
              />
              <Button
                style={{ ...styles.saveCurrentFilters }}
                disabled={!isShowSaveAsCol ? true : false}
                onClick={(event) =>
                  this.setState({ modal: 'USERINPUT', show: false, value: '', isCollectionSave: true })
                }
                text={t('SAVE_COLLECTION')}
              />
              <div
                style={{
                  height: '1px',
                  width: reqWidth + 'px',
                  backgroundColor: 'var(--separator-color',
                  display: window.gs.filterNames != null && window.gs.filterNames.length > 0 ? 'block' : 'none'
                }}
              />
              <div
                id="loadSearch"
                style={{
                  ...styles.loadFiltersTxt,
                  display: window.gs.filterNames != null && window.gs.filterNames.length > 0 ? 'block' : 'none'
                }}>
                {t('LOAD_SEARCH')}
              </div>
              <div>
                {window.gs.filterNames != null
                  ? _.map(window.gs.filterNames, (name, index) => {
                      return (
                        <div
                          onMouseEnter={() => this.setState({ hoveredFilter: name })}
                          onMouseLeave={() => this.setState({ hoveredFilter: null })}
                          onClick={() => {
                            this.onClickApplyFilter(name);
                          }}
                          key={index}
                          style={{
                            padding: '4px 10px',
                            cursor: 'pointer',
                            background:
                              this.state.hoveredFilter === name
                                ? 'var(--primary-elements-bg)'
                                : 'var(--primary-header-bg)',
                            color:
                              this.state.hoveredFilter === name
                                ? 'var(--header-basic-font)'
                                : 'var(--primary-font-color)'
                          }}>
                          {/* <span style={{ ...styles.filterNames }}> */}

                          <ToolTip
                            text={name}
                            style={{
                              overflow: 'hidden',
                              maxWidth: '162px',
                              display: 'inline-block',
                              whiteSpace: 'nowrap',
                              ...styles.filterNames
                            }}>
                            <Div className="name">{name}</Div>
                          </ToolTip>
                          {/* </span> */}
                          {this.state.hoveredFilter == name ? (
                            <div
                              id="deleteIcon"
                              onClick={(e) => this.deleteFilter(e, name)}
                              style={{
                                ...styles.button,
                                backgroundImage: ThemeSetup.getBackgroundURL('delete_asset.svg')
                              }}
                            />
                          ) : null}

                          {this.state.hoveredFilter == name ? (
                            <div
                              id="editIcon"
                              style={{
                                ...styles.button,
                                backgroundImage: ThemeSetup.getBackgroundURL('edit_asset.svg')
                              }}
                              onClick={(event) => {
                                event.stopPropagation();
                                this.setState({ modal: 'USERINPUT', show: false, value: name });
                                this.currentFilterName = name;
                              }}
                            />
                          ) : null}
                        </div>
                      );
                    })
                  : null}
              </div>
            </div>
          </Popover>
        ) : null}
        {this.state.modal == 'USERINPUT' ? (
          <Modal
            closeOnEsc
            closeOnOutsideClick
            name="FiltersPopoverModal"
            title={
              this.state.isCollectionSave
                ? t('CREATE_NEW_COLLECTION')
                : !StringUtil.isNull(this.currentFilterName)
                ? t('ENTER_FILTER_NEW_NAME', { FILTER: this.currentFilterName })
                : t('ENTER_FILTER_NAME')
            }
            buttons={[
              { label: t('CANCEL'), type: 'CANCEL', onClick: this.onClose },
              { label: t('SAVE'), type: 'PRIMARY', onClick: this.saveFilter }
            ]}
            onClose={this.onClose}>
            <div>
              <input
                type="text"
                placeholder={t('NAME')}
                value={this.state.value}
                onChange={this.onChange}
                onKeyDown={this.onKeyDown}
                style={{ width: '100%' }}
              />
            </div>
          </Modal>
        ) : null}
      </div>
    );
  }

  onClickApplyFilter(filterName) {
    this.props.issueApplyFilter(filterName);
    this.setState({ show: false });
  }

  deleteFilter(e, name) {
    e.stopPropagation();
    this.issueEditFilter('Remove', name);
  }

  loadFilters = () => {
    const query = new LoadFiltersQuery();
    const msg = new LoadFiltersMsg();
    query.message = msg;
    query.run().then(
      (resp) => {
        window.gs.filterNames = resp.getFilterNames();
        if (this._isMounted) {
          this.forceUpdate();
        }
      },
      (error) => {
        ErrorHandler.handleError(error);
      }
    );
  };

  saveFilter = () => {
    const newName = this.state.value.trim();
    if (StringUtil.isNotEmpty(newName)) {
      if (this.state.isCollectionSave) {
        this.saveCollection(newName);
      } else {
        if (!StringUtil.isNull(this.currentFilterName)) {
          this.issueEditFilter('Edit', newName, this.currentFilterName);
        } else this.issueEditFilter('Add', newName, null);
      }
    }

    this.onClose();
  };

  issueEditFilter(operation, newName, oldName) {
    const query = new EditFiltersQuery();
    const msg = new EditFiltersMsg();
    msg.setOperationType(operation);
    msg.setFilterNewName(newName);
    msg.setFilterOldName(oldName);
    query.message = msg;
    query.run().then(
      (resp) => {
        if (resp.isSuccess()) {
          this.loadFilters();
          //Filter saved successfully. may need to show some auto close pop up.
        }
      },
      (error) => {
        ErrorHandler.handleError(error);
      }
    );
  }
}

const styles = {
  button: {
    width: '16px',
    height: '16px',
    float: 'right',
    marginRight: '10px',
    backgroundRepeat: 'no-repeat',
    cursor: 'pointer',
    marginTop: 6
  },
  saveCurrentFilters: {
    padding: '10px',
    color: 'var(--primary-style-color)',
    fontFamily: 'Montserrat',
    cursor: 'pointer'
  },
  filterNames: {
    height: '24px',
    width: '210px',
    color: 'var(--primary-font-color)',
    fontFamily: 'Montserrat',
    fontSize: '16px',
    lineHeight: '30px',
    margin: '.1em .5em',
    cursor: 'pointer'
  },
  loadFiltersTxt: {
    padding: '10px 10px 3px',
    color: '#B5B5B5',
    fontFamily: 'Montserrat'
  }
};
